module.exports = __webpack_public_path__ + "img/slide2-8.32359956.png";